import { OverrideToken } from 'antd/es/theme/interface';

/**
 * Permette di sovrascrivere i token di ant relativi ai componenti
 */
export const uiThemeComponentTokens = {
  // es. Affix: { ... }
  Layout: {
    headerBg: '#ffffff',
    bodyBg: '#F2F6FA',
  },
  Button: {
    controlOutline: 'none',
  },
} satisfies OverrideToken;
